import drop from "lodash/drop";
import take from "lodash/take";
import shuffle from "lodash/shuffle";
export function getCurrentPageNumber(param) {
    let { total , limit , rowCount  } = param;
    if (rowCount) {
        return Math.max(1, Math.ceil(rowCount / limit));
    } else {
        return Math.max(1, Math.ceil(total / limit));
    }
}
export const getCurrentPage = (offset, limit)=>{
    return Math.max(offset / limit + 1, 1);
};
export const filterData = (items, param)=>{
    const defaultParamLength = 2 // default param object is {page: 1, limit: 10}
    ;
    if (Object.keys(param).length !== defaultParamLength) {
        return shuffle(items);
    } else {
        return items;
    }
};
export const getPaginatedItems = (param)=>{
    let { items =[] , page =1 , limit =10 , loadMore =false , param: param1 = {}  } = param;
    let data = [];
    if (!items) return [];
    const total = items.length;
    items = filterData(items, param1);
    if (loadMore) {
        data = take(items, page * limit);
    } else {
        if (page * limit > total) return getPaginatedItems({
            items,
            page: page - 1,
            limit
        });
        data = take(drop(items, (page - 1) * limit), limit);
    }
    return {
        data,
        page,
        limit,
        total
    };
} // export default getPaginatedItems;
;
